angular.module('lf.common')

.directive('cookieDisclaimer', function ($rootScope) {
  return function (scope, el, attrs) {
    if (document.location.pathname.indexOf('/legal/') > -1) {
      return;
    }
    var pageCount = $.cookie('euPageCount', Number) || 0;
    if (pageCount < 1) {
      $.cookie('euPageCount', ++pageCount, {path: '/'});
    }
    else {
      $.cookie('euCookie', 'true', { expires: 182, path: '/'});
    }
  }
})